module.exports = __webpack_public_path__ + "img/protection.10b35b35.svg";